export const A_RequestFeatures = {

    onError: 'A_Request_onError',

    onInit: 'A_Request_onInit',

    onAfterInit: 'A_Request_onAfterInit',

    onParse: 'A_Request_onParse',

    onValidate: 'A_Request_onValidate',

    onClose: 'A_Request_onClose',

    onAborted: 'A_Request_onAborted',

    onTimeout: 'A_Request_onTimeout',

    onData: 'A_Request_onData',

    onEnd: 'A_Request_onEnd',

    onBodyParse: 'A_Request_onBodyParse',

    onQueryParse: 'A_Request_onQueryParse',

    onParamsParse: 'A_Request_onParamsParse',

    onCookiesParse: 'A_Request_onCookiesParse',
} as const
